import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [斋月活动主页接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943542
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/act_ramadan_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/act_ramadan_homepage',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

interface Item {
  rank: string // 排名，类型为字符串
  avatar: string // 头像，类型为字符串
  name: string // 用户名，类型为字符串
  pearl: number // 珍珠数量，类型为数字
  dollar: number // 美元金额，类型为数字
  value: number // 值，类型为数字
  mid: number
}

interface InitialStateType {
  tasks: {
    icon: string // 图标，类型为字符串
    title: string // 任务标题，类型为字符串
    pearl: number // 珍珠数量，类型为数字
    task_cur: number // 当前任务进度，类型为数字
    task_need: number // 需要完成的任务数量，类型为数字
    state: 0 | 1 // 状态，0 表示去完成，1 表示完成
  }[]
  ranks: {
    highest_dollar: number
    me: Item
    list: Item[]
  }[]
  time: string
}

const initialState: Partial<InitialStateType> = {}

export const RamadanSlice = createSlice({
  name: 'Ramadan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload.data)
    })
  },
})

export default RamadanSlice.reducer

export const useRamadanState = () => {
  const data = useSelector((state) => {
    return state.Ramadan
  })
  return data
}
